module.exports = __webpack_public_path__ + "img/21.331b5b5e.webp";